import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from 'antd';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import './App.css';

const { Content } = Layout;

function App() {
  return (
    <Layout className="app">
      <Header />
      <Content>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </Content>
      <Footer />
    </Layout>
  );
}

export default App;